export default __webpack_public_path__ + "static/media/step_3_select_project.17d84d14.png";